export default __webpack_public_path__ + "static/media/powerPylon.3b4d7f1a.svg";